module.exports = __webpack_public_path__ + "img/feature.4ddb8a23.png";